<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-8', 'col-md-12']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-3']">
                                    {{Convocatoria.titulo}}
                                    <span v-if="parseInt(Convocatoria.hoy)" :class="['fa-pulse', 'badge', 'badge-light', 'pull-right', 'p-2', 'colorRedBell', 'fuente13']" style="width: 100px;">
                                        Nuevo
                                    </span>
                                </h3>
                                
                                <hr :class="['mt-1', 'mb-3']">
                                <h4>
                                    {{Convocatoria.subtitulo}}
                                </h4>
                                <div :class="['row', '']">
                                    <div :class="['col-lg-12', 'mt-4']">
                                        <div><i>Lo(a) invitamos a participar de la siguiente convocatoria:</i></div>
                                        <table :class="['table']">
                                            <tbody>
                                                <tr>
                                                    <td><b>Vacantes</b></td>
                                                    <td>{{Convocatoria.vacante}}</td>
                                                </tr>

                                                <tr>
                                                    <td><b>Fecha</b></td>
                                                    <td>{{Convocatoria.fecha_publicacion_inicio_es}} Hasta {{Convocatoria.fecha_publicacion_fin_es}}</td>
                                                </tr>

                                                <tr>
                                                    <td><b>Informaci&oacute;n</b></td>
                                                    <td><div style="text-align: justify;" v-html="Convocatoria.contenido"></div></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div :class="['row', '']">
                                    <div :class="['col-lg-12', 'mt-4']">
                                        <i>Etapas de la convocatoria</i>

                                        <ol>
                                            <li v-for="(val, key) in Etapas" :key="key" :class="['mt-4']">
                                               <b>{{val.etapa_convocatoria}} <span v-if="parseInt(val.hoy)" :class="['fa-pulse', 'colorRedBell', 'p-1', 'mb-2', 'badge']">Nuevo</span></b>
                                               <div>
                                                    <!--
                                                    <pdf
                                                        :src="urlEtapa[key]"
                                                        @num-pages="pageCount = $event"
                                                        @page-loaded="currentPage = $event"
                                                    ></pdf>
                                                    -->
                                                    <PdfThumbnail :fileUrl="urlEtapa[key]" :width="120" :height="120" :target="'_blank'"></PdfThumbnail>
                                                    <button @click="downloadItem(base_url+'webserviceserver/fileCors?file='+val.file+'&dir=convocatoria', val.file)" :title="val.file" :alt="'Descargar '+val.file" :class="['btn', 'btn-success']">
                                                        <i class="fa fa-download ml-2" aria-hidden="true"></i>
                                                        Descargar
                                                    </button>
                                                </div>
                                            </li>

                                            <li v-if="Etapas.length<1">
                                                <div class="alert alert-warning" role="alert">
                                                    Aun no hay etapas para esta convocatoria
                                                </div>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div :class="['col-lg-4', 'col-md-4', 'p4']">
                        <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm']">
                            <div :class="['box-header', 'with-border']">
                                <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'ml-2', 'bolder']" >Otras convocatorias</h5>
                            </div>

                            <hr :class="['mb-1', 'mt-1']">
                            <div :class="['box-body']" style=" ">
                                <div :class="['list-group', 'pb-1']">
                                    <ul :class="['widget']">
                                        <li v-for="(val, key) in Convocatorias" :key="key" v-if="id!=val.id">
                                            <router-link :class="['thumb']" :to="'/noticia/'+val.id" href="" title="">
                                                <img :src="empresa.path_file_logo" style="width:80px; height:60px" alt="" title="">
                                            </router-link>
                                            <h6 style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                                                <router-link :to="'/convocatoria/'+val.id" >{{val.titulo}}</router-link>
                                            </h6>

                                            <div class="commentmetadata"><i :class="['fa', 'fa-calendar', 'mr-2']"></i>Desde {{val.fecha_publicacion_inicio_es}} Hasta {{val.fecha_publicacion_fin_es}} </div>
                                        </li>

                                        <li>
                                            <router-link :to="'/convocatorias'" :class="['btn', 'btn-primary', 'btn-block']">VER MAS </router-link>
                                        </li>

                                        <li v-if="Convocatorias.length<1">Sin resultados</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import pdf from 'vue-pdf';
    import PdfThumbnail from '@/components/PdfThumbnail.vue';
    export default {
        name: 'Convocatoria',
        components:{
            pdf,
            PdfThumbnail,
        },
        computed:{
            ...mapState(['loading','globales','empresa']),
            urlEtapa(){
                return this.Etapas.map((item)=>{
                    this.path_file_download = `${window.baseUrl}webserviceserver/fileCors?file=${item.file}&dir=convocatoria`;
                    return this.path_file_download;
                });
            }
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Convocatoria || "+((this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM");
            this.getConvocatoria();
            this.getConvocatorias();
        },
        data(){
            return{
                id: (this.$route.params.id)?this.$route.params.id:1,
                Anio:[],
                formSearch:{
                    anio: (new Date()).getFullYear(),
                    mes:this.str_pad(((new Date()).getMonth()+1), 2, '0', 'STR_PAD_LEFT'),
                },
                Convocatoria:{},
                Etapas:[],
                Convocatorias:[],

                currentPage: 0,
                pageCount: 0,

                path_file_download:"",
                base_url: `${window.baseUrl}`,
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            getConvocatoria(){
                this.setLoading(true);
                this.$http.get('webserviceserver/convocatoria/'+this.id).then((res)=>{
                    if(res.data.Announcement)
                        this.Convocatoria   = res.data.Announcement;
                    if(this.Convocatoria)
                        this.Etapas         = res.data.Announcement.procesos;

                    //console.log(this.Etapas);
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
            getConvocatorias(){
                this.setLoading(true);
                
                this.$http.get('webserviceserver/convocatorias?limit=15').then((res)=>{
                    this.Convocatorias   = res.data.Announcement;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>
